"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TikTokEmbed1Schema = void 0;
exports.TikTokEmbed1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/tiktok-embed/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TikTokEmbed1",
    "description": "Embed a TikTok video",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:tiktok-embed:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "url": {
                    "type": "string",
                    "pattern": "^https:\\/\\/www\\.tiktok\\.com\\/@[a-zA-Z0-9_.]+\\/video\\/[0-9]+"
                }
            },
            "required": [
                "url"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy90aWt0b2stZW1iZWQvMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxrQkFBa0IsR0FBRztJQUNoQyxLQUFLLEVBQUUsaUZBQWlGO0lBQ3hGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLGNBQWM7SUFDdkIsYUFBYSxFQUFFLHNCQUFzQjtJQUNyQyxNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04seUNBQXlDO2FBQzFDO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixZQUFZLEVBQUU7Z0JBQ1osS0FBSyxFQUFFO29CQUNMLE1BQU0sRUFBRSxRQUFRO29CQUNoQixTQUFTLEVBQUUsb0VBQW9FO2lCQUNoRjthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLEtBQUs7YUFDTjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9